<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.especialista.labels.titulo")',
        :voltarPara='{ route: "Especialistas" }'
    )
    .formulario-especialista
        h3.formulario-especialista__titulo {{ $t('mensagens.especialista.labels.dadosCadastrais') }}
        .formulario-especialista__card
            .input-field
                label.input-field__label.obrigatorio {{ $t('mensagens.especialista.labels.idBunge') }}
                input.input-field__input(
                    :placeholder='$t("mensagens.especialista.labels.descricaoId")',
                    v-model='especialista.idBunge'
                )
            .input-field
                label.input-field__label.obrigatorio {{ $t('mensagens.especialista.labels.nome') }}
                input.input-field__input(
                    :placeholder='$t("mensagens.especialista.labels.descricao")',
                    v-model='especialista.nome'
                )
            .select-field
                label.select-field__label.obrigatorio {{ $t('mensagens.especialista.labels.regionais') }}
                el-select.select-field__input(
                    :loading='carregandoRegionais',
                    :placeholder='$t("mensagens.comuns.selecione")',
                    v-model='idsRegionais',
                    multiple,
                    clearable,
                    filterable
                )
                    el-option(
                        v-for='({ nome, id }, index) in regionais',
                        :key='`regional-${id}-${index}`',
                        :label='nome',
                        :value='id'
                    )
        .footer
            .footer__btn.voltar(@click='irParaEspecialistas')
                i.mdi.mdi-arrow-left
                span {{ $t('mensagens.comuns.voltar') }}
            .footer__btn.salvar(@click='fluxoSalvarEspecialista')
                span {{ $t('mensagens.comuns.salvar') }}
                i.mdi.mdi-arrow-right
</template>

<script>
import services from '@/views/contratos-originacao/especialista/services';
import contratoOriginacaoService from '@/services/ContratoOriginacaoService';
import EventBus from '@/utils/eventBus';

export default {
    name: 'FormularioEspecialista',
    components: {
        BaseHeader: () => import('@/components/BaseHeader')
    },
    data() {
        return {
            regionais: [],
            idsRegionais: [],
            especialista: {
                id: '',
                nome: '',
                idBunge: '',
                idsRegionais: []
            },
            carregandoRegionais: true
        };
    },
    computed: {
        isEdicao() {
            return Boolean(this.$route.params.id);
        }
    },
    mounted() {
        this.carregarDados();
    },
    methods: {
        async carregarDados() {
            this.loadingScreen(true);
            await this.buscarRegionais();
            if (this.isEdicao) {
                await this.carregarEspecialista(this.$route.params.id);
            }
            this.loadingScreen(false);
        },
        async carregarEspecialista(id) {
            try {
                const { data } = await services.buscarEspecialistaPorId(id);
                this.especialista = {
                    id: data.id,
                    nome: data.nome,
                    idBunge: data.idBunge,
                    idsRegionais: data.idsRegionais || []
                };
                this.idsRegionais = data.idsRegionais || [];
            } catch (error) {
                this.$notify.error({
                    message: error?.message || error
                });
            }
        },
        buscarRegionais() {
            return contratoOriginacaoService
                .buscarRegionais()
                .then(({ data }) => {
                    if (data.length > 0) {
                        this.regionais = data;
                    }
                    this.carregandoRegionais = false;
                });
        },
        irParaEspecialistas() {
            this.$router.push({ name: 'Especialistas' });
        },
        fluxoSalvarEspecialista() {
            const nomeInvalido = !this.especialista.nome;
            const idBungeInvalido = !this.especialista.idBunge;
            const regionaisInvalidas =
                !this.idsRegionais || this.idsRegionais.length === 0;
            const mensagemNomeVazio = this.$t(
                'mensagens.especialista.labels.nomeVazio'
            );
            const mensagemIDBungeVazio = this.$t(
                'mensagens.especialista.labels.idBungeVazio'
            );
            const mensagemRegionaisVazia = this.$t(
                'mensagens.especialista.labels.regionaisVazia'
            );

            if (idBungeInvalido) {
                return this.$notify.error(mensagemIDBungeVazio);
            }
            if (nomeInvalido) {
                return this.$notify.error(mensagemNomeVazio);
            }
            if (regionaisInvalidas) {
                return this.$notify.error(mensagemRegionaisVazia);
            }
            if (this.isEdicao) {
                this.editarEspecialista();
            } else {
                this.cadastrarEspecialista();
            }
        },
        cadastrarEspecialista() {
            const mensagemSucesso = this.$t(
                'mensagens.especialista.labels.registroCadastrado'
            );
            const params = {
                nome: this.especialista.nome,
                idBunge: this.especialista.idBunge,
                idsRegionais: this.idsRegionais
            };

            return services.cadastrarEspecialista(params).then(() => {
                this.$notify.success(mensagemSucesso);
                this.irParaEspecialistas();
            });
        },
        editarEspecialista() {
            const mensagemSucesso = this.$t(
                'mensagens.especialista.labels.registroEditado'
            );
            const params = {
                id: this.especialista.id,
                nome: this.especialista.nome,
                idBunge: this.especialista.idBunge,
                idsRegionais: this.idsRegionais
            };

            return services.editarEspecialista(params).then(() => {
                this.$notify.success(mensagemSucesso);
                this.irParaEspecialistas();
            });
        },
        loadingScreen(isLoading) {
            const options = {
                mostrarLoading: isLoading,
                lockMessage: this.$t('mensagens.sistema.carregando')
            };
            EventBus.$emit('emit-componente-carregando', options);
        }
    }
};
</script>

<style lang="scss">
.formulario-especialista {
    margin: 20px;
    &__titulo {
        margin-top: 24px;
        font-weight: 500;
    }
    &__card {
        margin-top: 10px;
        background-color: $white;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        border-radius: $default-border-radius;
        @include default-box-shadow();
    }
    .select-field {
        width: 50%;
        display: flex;
        flex-direction: column;
        gap: 3px;
        &__label {
            color: $primary;
            font-weight: bold;
        }
        &__input {
            border-radius: $default-border-radius;
            outline: 0;
        }
    }
    .input-field {
        width: 50%;
        display: flex;
        flex-direction: column;
        gap: 3px;
        &__label {
            color: $primary;
            font-weight: bold;
        }
        &__input {
            height: 40px;
            width: 100%;
            border-radius: $default-border-radius;
            border: 1px solid $default-border-color;
            outline: 0;
            padding: 0 15px;
        }
    }
    .obrigatorio::after {
        content: '* ';
        color: red;
        margin-left: 3px;
    }
}

.footer {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.footer__btn {
    width: 100px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
    border-radius: $default-border-radius;
    cursor: pointer;

    .mdi-arrow-left {
        color: var(--primary);
    }

    .mdi-arrow-right {
        color: $white;
    }
}

.salvar {
    background-color: var(--primary);
    color: $white;
}

.salvar:hover {
    background-color: var(--secondary);
}

.footer__btn.voltar {
    background-color: transparent;
    color: var(--primary);
    border: 1px solid var(--primary);
}

.footer__btn.voltar:hover {
    background-color: var(--primary);
    color: $white;

    .mdi-arrow-left {
        color: $white;
    }
}
</style>
